module.exports = __webpack_public_path__ + "static/img/M-1.672def1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/M-1.png
// module id = Y+YB
// module chunks = 0